var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 220C170.751 220 220 170.751 220 110C220 49.2487 170.751 0 110 0C49.2487 0 0 49.2487 0 110C0 170.751 49.2487 220 110 220Z",
    fill: "#7269EF",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_132_16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.905 147.892V169.082C112.905 170.69 111.601 172 110 172C108.399 172 107.095 170.69 107.095 169.082V147.892C98.2066 147.18 90.1927 143.233 84.226 137.239C77.6032 130.595 73.5 121.428 73.5 111.347C73.5 109.738 74.8036 108.429 76.4046 108.429C78.0056 108.429 79.3092 109.738 79.3092 111.347C79.3092 119.819 82.765 127.527 88.3292 133.117C93.8935 138.707 101.566 142.179 110 142.179C118.434 142.179 126.107 138.707 131.671 133.117C137.235 127.527 140.691 119.819 140.691 111.347C140.691 109.738 141.994 108.429 143.595 108.429C145.196 108.429 146.5 109.738 146.5 111.347C146.5 121.437 142.397 130.604 135.783 137.248C129.807 143.242 121.793 147.18 112.905 147.892ZM110.192 64C115.774 64 120.849 66.2939 124.523 69.9854C128.198 73.6768 130.481 78.7744 130.481 84.3818V110.749C130.481 116.356 128.198 121.454 124.523 125.146C120.849 128.837 115.774 131.131 110.192 131.131C104.611 131.131 99.5364 128.837 95.8619 125.146C92.1874 121.454 89.904 116.356 89.904 110.749V84.3818C89.904 78.7744 92.1874 73.6768 95.8619 69.9854C99.5364 66.2939 104.611 64 110.192 64ZM120.411 74.1162C117.786 71.4795 114.164 69.8447 110.192 69.8447C106.212 69.8447 102.599 71.4795 99.9739 74.1162C97.3492 76.7529 95.722 80.3916 95.722 84.3818V110.749C95.722 114.748 97.3492 118.378 99.9739 121.015C102.599 123.651 106.221 125.286 110.192 125.286C114.173 125.286 117.786 123.651 120.411 121.015C123.036 118.378 124.663 114.739 124.663 110.749V84.3818C124.672 80.3828 123.036 76.7529 120.411 74.1162Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144 74L144 98",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.5 98L75.5 74",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.5 80L158.5 93",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 92L61 79",
    stroke: "black",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_132_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73,
    height: 108,
    fill: "white",
    transform: "translate(73.5 64)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio-icon.9e99c766d3f5609f87a0dd8cb1603f05.svg";
export { ForwardRef as ReactComponent };